import { render, staticRenderFns } from "./WholePopover.vue?vue&type=template&id=58a66ba5&scoped=true"
import script from "./WholePopover.vue?vue&type=script&lang=js"
export * from "./WholePopover.vue?vue&type=script&lang=js"
import style0 from "./WholePopover.vue?vue&type=style&index=0&id=58a66ba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a66ba5",
  null
  
)

export default component.exports